export const oneProjectIitialState = {
    oneproject: null
};